import { CareConneRoomItem, UserByUnit } from "@app/models/user.model";
import { SlideUpWindowByStudentState } from "./slide-up-window-by-student.state";
import { Store } from "@ngxs/store";
import { CareConneSenderEmpty } from "@app/store/record/record.classes";
import { ActivatedRoute, Router } from "@angular/router";
import { ModalService } from "@app/services/modal.service";
import { RoomCategory } from "@app/shared/enum/care-conne.enum";

export function dedupeRooms(rooms: CareConneRoomItem[]) {
    const map = new Map();
    rooms.forEach((n) => {
        map.set(n.roomId, n);
    });
    return Array.from(map.values());
}

export function bindingSelectedRoomCounter(state: SlideUpWindowByStudentState, student: UserByUnit) {
    const totalRooms = dedupeRooms(student?.roomDataByUnit.flatMap((item) => item.rooms)).length;
    if (totalRooms === 0) return '0';
    const selectedRooms = state.selectedRoomIdsByUser[student?.daicd];
    if (!selectedRooms) return `0/${totalRooms}`;
    return `${selectedRooms.roomIds.length}/${totalRooms}`;
}

export async function closeModal(
    state: SlideUpWindowByStudentState,
    store: Store,
    isReset: boolean = true,
    route: ActivatedRoute,
    router: Router,
    modalService: ModalService
) {
    state.isInited = false;
    if (isReset) {
        store.dispatch(new CareConneSenderEmpty());
    }
    await new Promise(resolve => setTimeout(resolve, 450));
    const modalId = route.snapshot.queryParams['modalId'];
    modalService.closeModal(modalId, { isOpening: false });
    router.navigate(['', { outlets: { modal: null } }], { relativeTo: route, skipLocationChange: true, replaceUrl: true });
}

type RoomPredicate = (room: CareConneRoomItem, carePass: number) => boolean;

export const ROOM_CONDITIONS: Record<string, RoomPredicate> = {
    [RoomCategory.SELFCHAT]: (r, carePass) => 
        r.type === 3 && r.userId === carePass,

    [RoomCategory.YOURCHAT]: (r, carePass) =>
        r.type === 3 && r.userId === carePass,

    [RoomCategory.GROUP]: (r) =>
        [2, 5, 6].includes(r.type),

    [RoomCategory.FAMILY]: (r) =>
        r.type === 1 && r.userInfo.some(i => i.roleId === 3),

    [RoomCategory.DAI]: (r) =>
        r.type === 1 && r.userInfo.some(i => i.roleId === 1),

    [RoomCategory.STAFF]: (r) =>
        r.type === 1 && r.userInfo.some(i => i.roleId === 2),

    [RoomCategory.EXTERNAL]: (r) =>
        r.type === 1 && r.userInfo.some(i => i.roleId === 4),
};